import type { SelectItem } from '@cartwhl/ui/atoms/Select';

export const INDUSTRY_FOCUS_OPTIONS: SelectItem[] = [
  { value: 'VIDEO_GAMES_INTERACTIVE', label: 'Video games & interactive' },
  { value: 'TV_MOVIES_CINEMATICS', label: 'Film, TV & cinematics' },
  { value: 'BRAND_MARKETING', label: 'Brand & marketing content' },
  { value: 'PERSONAL_INDIE', label: 'Personal or indie projects' },
  { value: 'OTHER', label: 'Something else' },
];

export const PRODUCT_FOCUS_OPTIONS: SelectItem[] = [
  { value: 'UNREAL', label: 'Unreal' },
  { value: 'MAYA', label: 'Maya' },
  { value: 'BLENDER', label: 'Blender' },
  { value: 'UNITY', label: 'Unity' },
  { value: 'OTHER', label: 'Something else' },
];
